import { MessageSquare, Phone, Wrench, Send } from "lucide-react";
import { smsHref, telHref, scrollTo } from "@/lib/actions";

export const MobileBar = () => {
  const items = [
    { label: "Text", icon: MessageSquare, type: "link", href: smsHref, testid: "mbar-text", primary: true },
    { label: "Call", icon: Phone, type: "link", href: telHref, testid: "mbar-call" },
    { label: "Services", icon: Wrench, type: "scroll", target: "#services", testid: "mbar-services" },
    { label: "Request", icon: Send, type: "scroll", target: "#contact", testid: "mbar-request" },
  ];
  return (
    <div data-testid="mobile-cta-bar" className="lg:hidden fixed bottom-0 left-0 right-0 z-50 grid grid-cols-4 bg-black/95 backdrop-blur-xl border-t border-white/10">
      {items.map((it) => {
        const Icon = it.icon;
        const cls = `flex flex-col items-center justify-center gap-1 py-3 transition-colors ${
          it.primary ? "bg-[#C8102E] text-white" : "text-gray-300 hover:text-[#C8102E]"
        }`;
        const inner = (
          <>
            <Icon size={20} />
            <span className="text-[11px] font-bold uppercase tracking-wide">{it.label}</span>
          </>
        );
        return it.type === "link" ? (
          <a key={it.label} href={it.href} data-testid={it.testid} className={cls}>{inner}</a>
        ) : (
          <button key={it.label} onClick={() => scrollTo(it.target)} data-testid={it.testid} className={cls}>{inner}</button>
        );
      })}
    </div>
  );
};
